import PropTypes from "prop-types";

import { makeKey } from "./differentiationHierarchyPanelUtils";

const StatusPills = ({ dataType, node, includedKeys }) => {
    const key = makeKey(node);
    const alreadyIncluded = includedKeys?.has?.(key);

    const isReportable = !!node?.reportFlag;

    return (
        <span className="d-inline-flex align-items-center">
            {isReportable && dataType === "CURRENT" && (
                <span className="diff-badge diff-badge--on-template">On Template</span>
            )}
            {alreadyIncluded && dataType === "DIFF" && (
                <span className="diff-badge diff-badge--on-template">On Template</span>
            )}
        </span>
    );
};

StatusPills.propTypes = {
    dataType: PropTypes.string,
    includedKeys: PropTypes.object,
    node: PropTypes.object.isRequired
};

StatusPills.defaultProps = {
    dataType: "",
    includedKeys: {}
};

export default StatusPills;
